import * as fromDatatype from "../datatype-library/index";

export interface bl_alg_cc_qc_set_project_link_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	qc_set_hdr_guid : fromDatatype.GuidDataFieldInterface;
    project_hdr_guid : fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	name: fromDatatype.TextDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	type: fromDatatype.VarcharArrayDatatypeInterface;
    descr : fromDatatype.TextDatatypeInterface;
}

export class bl_alg_cc_qc_set_project_link_RowClass
	implements bl_alg_cc_qc_set_project_link_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	qc_set_hdr_guid : fromDatatype.GuidDataFieldInterface;
    project_hdr_guid : fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	name: fromDatatype.TextDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	type: fromDatatype.VarcharArrayDatatypeInterface;
    descr : fromDatatype.TextDatatypeInterface;
}
